import { PersonDto } from 'dtos'
import * as yup from 'yup'

export class VehicleIncorrectMileageResolutionDto {
  needsIncorrectMileageResolutionDateTime?: string = undefined
  needsIncorrectMileageResolutionByPerson?: PersonDto = undefined
  incorrectMileageResolutionIssue?: string = undefined
  incorrectMileageResolutionOdometerReadingMileage?: number = undefined
  incorrectMileageResolutionOdometerReadingUnitOfMeasurement?: string = undefined
  incorrectMileageResolutionNotes?: string = undefined
  incorrectMileageResolvedDateTime?: string = undefined
  incorrectMileageResolvedByPerson?: PersonDto = undefined
}

export const vehicleIncorrectMileageResolutionValidationSchema = yup.object({
  incorrectMileageResolutionIssue: yup.string().required('Incorrect Mileage Resolution Issue is required.'),
  incorrectMileageResolutionOdometerReadingMileage: yup
    .number()
    .required('Incorrect Mileage Resolution Odometer Reading Mileage is required.'),
  incorrectMileageResolutionOdometerReadingUnitOfMeasurement: yup
    .string()
    .required('Incorrect Mileage Resolution Odometer Reading Unit Of Measurement is required.'),
  incorrectMileageResolutionNotes: yup.string().required('Incorrect Mileage Resolution Notes is required.')
})
